import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { TwoFactorService } from 'src/app/deebr/service/two-factor.service';

@Component({
  selector: 'app-deebr-2fa-activate',
  template: `
    <nb-layout>
      <nb-layout-column>
        <nb-card style="max-width: 500px; margin: 50px auto;">
          <nb-card-header>Activation double authentification</nb-card-header>
          <nb-card-body>
            <nb-alert *ngIf="message" status="basic">{{ message }}</nb-alert>
            <nb-alert *ngIf="error" status="danger">{{ error }}</nb-alert>
            <div *ngIf="loading" class="text-center">
                <nb-spinner></nb-spinner>
                <p>Activation en cours...</p>
            </div>
          </nb-card-body>
        </nb-card>
      </nb-layout-column>
    </nb-layout>
  `,
  styles: [`
    nb-card { border-radius: 10px; }
  `],
  standalone: false
})
export class Deebr2faActivateComponent implements OnInit {

  message = '';
  error = '';
  loading = true;

  constructor(
    private route: ActivatedRoute,
    private twoFactorService: TwoFactorService,
    private router: Router
  ) { }

  ngOnInit(): void {
    const uid = this.route.snapshot.paramMap.get('uid');
    const token = this.route.snapshot.paramMap.get('token');

    if (uid && token) {
      this.twoFactorService.activate2FA(uid, token).subscribe({
        next: () => {
          this.loading = false;
          this.message = "Votre double authentification a été activée avec succès. Vous pouvez fermer cet onglet et vous connecter.";
        },
        error: (err: any) => {
          this.loading = false;
          this.error = "Le lien est invalide ou a expiré.";
        }
      });
    } else {
      this.loading = false;
      this.error = "Lien incomplet.";
    }
  }
}
